module.exports = __webpack_public_path__ + "static/media/androidstudiologo.a110aa16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/androidstudiologo.jpg
// module id = 826
// module chunks = 0